import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/telecom-services/telecom-industry-cta.webp";
import { Link } from "gatsby";

function Telecomindustrycta() {
  return (
    <section className="telecomindustry_cta p-100 text_white">
      <Container>
        <div
          className="tele-industry"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <Row>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-md-6">
              <h2>
                Do You Want to Start Innovating in the{" "}
                <span>Telecom Industry?</span>
              </h2>
              <p>
                We set the foundation for your telecom software development
                journey with our extensive knowledge and innovative strategies.
              </p>
              <Link
                style={{ background: "#f47a14", color: "#fff" }}
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Telecomindustrycta;
